import { Button, Form, Progress, Card, Upload } from '@nackle/paper';
import { Picture, CloudUpload, Cross } from '@nackle/icons';
import React, { Component, SyntheticEvent } from 'react';
import './image-upload.less';

const { Dragger } = Upload;

interface ImageUploadProps {
    readonly imageUrl: string | null;
    readonly handleImage: (image: string | ArrayBuffer | null) => void;
    readonly removeImage: () => void;
}

interface State {
    file: File | null;
    dimensions: { height: number; width: number } | null;
}

export default class ImageUpload extends Component<ImageUploadProps, State> {
    state: State = {
        file: null,
        dimensions: null,
    };

    componentDidUpdate(prevProps) {
        if (!!prevProps.imageUrl && !this.props.imageUrl) {
            this.setState({ file: null });
        }
    }

    onDrop = info => {
        const reader = new FileReader();
        reader.readAsDataURL(info.file);
        reader.addEventListener('loadend', () => this.props.handleImage(reader.result), false);
        this.setState({ file: info.file });
    };

    handleImageLoaded = (evt: SyntheticEvent<HTMLImageElement, Event>) => {
        if (evt.target) {
            const image = (evt.target as HTMLImageElement);
            const dimensions = {
                width: image.naturalWidth,
                height: image.naturalHeight,
            };
            this.setState({ dimensions });
        }
    };

    render() {
        const { imageUrl } = this.props;
        const { dimensions, file } = this.state;
        const url = imageUrl;

        const draggerProps = {
            name: 'file',
            customRequest: this.onDrop
        };

        if (url) {
            return (
                <Card
                    title=""
                    className="game-image-upload-wrapper"
                >
                    <p>
                        <Picture className="dragger-icons"/>
                        { file ? 'New image: ' + file.name : 'Existing image' }
                        { dimensions ? ` (${dimensions.width} × ${dimensions.height} px)` : ''}
                    </p>
                    
                    <Form>
                        <img
                            alt="Image preview"
                            className="image-preview"
                            onLoad={this.handleImageLoaded}
                            src={url}
                        />
                    </Form>
                    <Button type="primary" className="remove-value-button" onClick={this.props.removeImage} style={{ marginTop: 14}}>
                        <Cross/>
                        Clear Image
                    </Button>
                </Card>
            );
        }

        if (file && file.name) {
            return (
                <Card
                    title=""
                    className="game-image-upload-wrapper"
                >
                    <Picture className="dragger-icons" />
                    <Progress />
                </Card>
            );
        }

        return (
            <Dragger {...draggerProps}>
                <Card
                    title={
                        <>
                            <Picture className="dragger-icons" />
                            No image selected
                        </>
                    }
                    className="card-dropzone"
                >
                    <div className="nkl-btn nkl-btn-lg image-dropzone-button">
                        <CloudUpload style={{paddingRight: 8, fontSize: 16}} />
                        Drop files here, or click to select files
                    </div>
                </Card>
            </Dragger>
        );
    }
}
